import React from 'react';
import { CtaButton } from './CtaButton';
import { IMAGES, PRICING_ANCHOR, TRUST_LINE } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-charcoal" data-id="element-77" data-mp="eilghbqnn7g7">
      <div className="pointer-events-none absolute inset-0 opacity-[0.14]" style={{
      backgroundImage: `url(${IMAGES.coachKettlebell})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} aria-hidden="true" data-id="element-78" data-mp="9lv0spiridvb" />
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(120% 70% at 50% 0%, rgba(197,163,92,0.10) 0%, rgba(12,12,13,0.88) 58%, #0c0c0d 100%)'
    }} aria-hidden="true" data-id="element-79" data-mp="x9ur5oc5w29d" />

      <div className="relative mx-auto max-w-content px-4 pb-8 pt-6 sm:px-6 sm:pb-10 sm:pt-8 lg:grid lg:max-w-6xl lg:grid-cols-[1fr_1.15fr] lg:items-center lg:gap-10 lg:px-8 lg:pb-14 lg:pt-10" data-id="element-80" data-mp="nekm0rqgverd">
        <div className="text-center lg:text-left" data-id="element-81" data-mp="384s6grzq2r4n">
          <p className="inline-flex items-center rounded-full border border-gold/40 bg-gold/[0.08] px-3 py-1 text-[9.5px] font-semibold uppercase tracking-[0.2em] text-gold sm:text-[11px]" data-id="element-82" data-mp="3j9k9t8cxxbej">
            ⚡ Professional Functional Coaching System
          </p>

          <h1 className="mt-3 font-display text-[32px] font-bold uppercase leading-[0.97] tracking-tight text-cream sm:text-[42px] lg:text-[54px]" data-id="element-83" data-mp="3e9fs5f0aqamq">
            The Complete <span className="text-gold" data-id="element-84" data-mp="30ggfrlvt8wje">Operating System</span> for
            Functional Training Coaches
          </h1>

          <p className="mx-auto mt-3 max-w-xl text-[14px] leading-snug text-mutedtext sm:text-base lg:mx-0" data-id="element-85" data-mp="35au9ljutqvly">
            Stop building sessions from scratch, reclaim your time, and bring
            more structure to your coaching — without spending hours
            programming everything manually.
          </p>
        </div>

        {/* Product — the visual hero */}
        <div className="relative mt-5 lg:mt-0" data-id="element-86" data-mp="2lk8u0h4r7n20">
          <div className="pointer-events-none absolute left-1/2 top-1/2 h-[85%] w-[112%] -translate-x-1/2 -translate-y-1/2 rounded-full" style={{
          background: 'radial-gradient(closest-side, rgba(62,58,50,0.95) 0%, rgba(30,29,27,0.6) 45%, rgba(12,12,13,0) 78%)'
        }} aria-hidden="true" data-id="element-87" data-mp="s1rqcip57wrn" />
          <div className="pointer-events-none absolute left-1/2 top-1/2 h-[55%] w-[80%] -translate-x-1/2 -translate-y-1/2 rounded-full" style={{
          background: 'radial-gradient(closest-side, rgba(197,163,92,0.22) 0%, rgba(197,163,92,0) 75%)'
        }} aria-hidden="true" data-id="element-88" data-mp="db2dzczy4bm7" />
          <img src={IMAGES.productBundle} alt="Functional Coach System complete digital bundle: six core module manuals, exercise library on tablet, session planners and coaching reference cards" className="relative mx-auto w-[95%] max-w-[560px] drop-shadow-[0_30px_45px_rgba(0,0,0,0.75)] lg:w-full lg:max-w-none" width={1500} height={1000} data-id="element-89" data-mp="x1wbim0zxfo7" />
        </div>

        <div className="relative mt-5 lg:col-start-1 lg:row-start-2 lg:mt-6" data-id="element-90" data-mp="21bfsnhwi11qr">
          <div className="mx-auto max-w-md lg:mx-0" data-id="element-91" data-mp="268y4bg1whv2g">
            <CtaButton href={PRICING_ANCHOR} data-id="element-92" data-mp="2b0pmp3awkuhi">
              🚀 Yes, I Want My System Now
            </CtaButton>
            <p className="mt-2.5 text-center text-[10px] font-medium uppercase tracking-[0.14em] text-mutedtext sm:text-[11px]" data-id="element-93" data-mp="2g02jafrktfxa">
              {TRUST_LINE}
            </p>
          </div>
        </div>
      </div>
    </header>;
}